import { useEffect, useRef, useState } from 'react';
import type { Task } from '@shared/types';
import { setDescription } from '@/lib/actions';
import { RichEditor } from '@/components/editor/RichEditor';
import { FileText } from '@/components/ui/icons';

/** Task description with autosave (debounced while typing, flushed on blur). */
export function TaskDescription({ task }: { task: Task }) {
  const [editing, setEditing] = useState(!!task.description);
  const timer = useRef<ReturnType<typeof setTimeout>>();
  const latest = useRef(task.description);
  useEffect(() => () => {
    clearTimeout(timer.current);
    if (latest.current !== task.description) setDescription(task.id, latest.current);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  if (!editing) {
    return (
      <button className="tm-add-desc" onClick={() => setEditing(true)}>
        <FileText size={15} />
        Add description
      </button>
    );
  }
  return (
    <div className="tm-desc">
      <RichEditor
        content={task.description}
        placeholder="Write something, or type '@' to mention someone"
        toolbar="fixed"
        autofocus={!task.description}
        onChange={(html) => {
          latest.current = html;
          clearTimeout(timer.current);
          timer.current = setTimeout(() => setDescription(task.id, html), 600);
        }}
        onBlur={(html) => {
          clearTimeout(timer.current);
          setDescription(task.id, html === '<p></p>' ? '' : html);
        }}
      />
    </div>
  );
}
